import React, { useState } from 'react';
import { Box, Card,Tab } from '@mui/material';
import DailyEscalationTemplateNew from 'src/templates/DailyEscalationTemplateNew';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import InteriorReport from 'src/templates/InteriorReport';

export default function DailyEscalationReportNew() {

   const [value, setValue] = useState('one');
      const handleChange = (event, newValue) => {
          setValue(newValue);
        };
  
  return (
    // <Box sx={{ p: 2 }}>
    //   <DailyEscalationTemplateNew fileName="VIDISKY_GatorsDockside_DailyOps.pdf" />
    // </Box>


      <Card>
                <TabContext value={value}>
                  <TabList
                      onChange={handleChange}
                      aria-label="deployment report tabs"
                      sx={{
                        px: 2,
                        bgcolor: 'background.neutral',
                        '& .MuiTab-root': {
                          typography: 'body2',
                          fontWeight: 500,
                          color: 'text.secondary',
                          minHeight: 48,
                          '&.Mui-selected': {
                            color: 'text.primary',
                            fontWeight: 600,
                          },
                        },
                        '& .MuiTabs-indicator': {
                          bgcolor: 'primary.main',
                        },
                      }}
                    >
                      <Tab
                        value="one"
                        label="Interior Report"
                      />
                      <Tab 
                        value="two" 
                        label="Exterior Report" />
                     
                    </TabList>
    
                <TabPanel value="one" index={0} sx={{ p: 0}}>                
                    <InteriorReport
                     fileName="VIDISKY_GatorsDockside_DailyOps.pdf"/>
                </TabPanel>
  
                <TabPanel value="two" index={1} sx={{ p: 0}}>
                    <DailyEscalationTemplateNew fileName="VIDISKY_GatorsDockside_DailyOps.pdf"/>

                </TabPanel>
                  
    
                   
                    
                </TabContext>
              </Card>
  );
}
